import { render, staticRenderFns } from "./LegalTemplate.vue?vue&type=template&id=788aa159&scoped=true&name=legal-template&"
import script from "./LegalTemplate.vue?vue&type=script&lang=js&"
export * from "./LegalTemplate.vue?vue&type=script&lang=js&"
import style0 from "./LegalTemplate.vue?vue&type=style&index=0&id=788aa159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788aa159",
  null
  
)

/* custom blocks */
import block0 from "./LegalTemplate.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports